import {Box, styled, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';

const StyledLabel = styled(Typography)(({theme}) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
  fontSize: 11,
  marginTop: theme.spacing(1),
  marginBottom: '3px'
}));

// eslint-disable-next-line react/prop-types
const FieldLabel = ({required, ...rest}) => {
  return (
    <Box>
      <Grid container alignItems="center" gap={0.5}>
        <StyledLabel {...rest} />
        {required && (
          <Typography color="error" mt={0.5}>
            *
          </Typography>
        )}
      </Grid>
    </Box>
  );
};

export default FieldLabel;
